import { gql } from "@apollo/client";

export const TRAVEL_ITINERARY = gql`
    query travelItinerary($culture: String!, $localizationSet: String = null) {
        travelItinerary(
            where: {localization: {culture: $culture, localizationSet: $localizationSet}}
        ) {
            displayText
            startDate
            description {
                html
            }
            included {
                html
            }
            notIncluded {
                html
            }
            packagePrice {
                html
            }
            paymentTerms {
                html
            }
            termsConditions {
                html
            }
            cancellationPolicy {
                html
            }
            activities {
                contentItems {
                    __typename
                    ... on ItineraryActivity {
                        activity
                        day
                        startTime
                        endTime
                        displayText
                        location {
                            latitude
                            longitude
                        }
                        gallery {
                            paths
                        }
                        brief {
                            html
                        }
                    }
                }
            }
        }
    }
`

export const EVENTS = gql`
    query Events($culture: String!) {
        event(
            where: {localization: {culture: $culture}}
        ) {
            displayText
            description
            startTime
            endTime
            cover {
                paths
            }
        }
    }
`